export default {
  endpoint: process.env.REACT_APP_BACKEND_URL ?? 'https://jenkins.temera.it/stoneisland-tmr-api/',
  gateEndpoint: process.env.REACT_APP_GATE_BACKEND_URL ?? 'http://127.0.0.1',
  gateMainPort: '7080',
  gateEmulationPort: '7082',
  gateSsePort: '7081',
}
